import {useAuth0} from "@auth0/auth0-react";
import {AudioTrack} from "../model/audio_track";

export function useAudioTrackAPI() {
    const {getAccessTokenSilently} = useAuth0();

    const getAllAudioTracks = (): Promise<AudioTrack[]> => {
        return new Promise((resolve, reject) => {
            getAccessTokenSilently().then((accessToken) => {
                fetch(`${process.env.REACT_APP_API_URL}/audio_track/admin`, {
                    headers: {
                        authorization: `Bearer ${accessToken}`,
                    },
                })
                    .then((response) => {
                        if (response.status === 200) {
                            response.json().then((data: AudioTrack[]) => resolve(data)).catch(reject);
                        } else {
                            reject(new Error("Failed to fetch audio tracks: " + response.statusText));
                        }
                    })
                    .catch(reject);
            }).catch(reject);
        });
    };

    const getAudioTrackById = (id: string): Promise<AudioTrack> => {
        return new Promise((resolve, reject) => {
            getAccessTokenSilently().then((accessToken) => {
                fetch(`${process.env.REACT_APP_API_URL}/audio_track/admin/${id}`, {
                    headers: {
                        authorization: `Bearer ${accessToken}`,
                    },
                })
                    .then((response) => {
                        if (response.status === 200) {
                            response.json().then((data: AudioTrack) => resolve(data)).catch(reject);
                        } else {
                            reject(new Error("Failed to fetch audio track: " + response.statusText));
                        }
                    })
                    .catch(reject);
            }).catch(reject);
        });
    };

    const createAudioTrack = (audioTrack: AudioTrack): Promise<AudioTrack> => {
        return new Promise((resolve, reject) => {
            getAccessTokenSilently().then((accessToken) => {
                fetch(`${process.env.REACT_APP_API_URL}/audio_track/admin`, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        authorization: `Bearer ${accessToken}`,
                    },
                    body: JSON.stringify(audioTrack)
                }).then((response) => {
                    if (response.status === 200) {
                        response.json().then((data: AudioTrack) => resolve(data)).catch(reject);
                    } else {
                        reject(new Error("Failed to create audio track: " + response.statusText));
                    }
                })
                    .catch(reject);
            }).catch(reject);
        });
    };

    const updateAudioTrack = (id: string, audioTrack: AudioTrack): Promise<AudioTrack> => {
        return new Promise((resolve, reject) => {
            getAccessTokenSilently().then((accessToken) => {
                fetch(`${process.env.REACT_APP_API_URL}/audio_track/admin/${id}`, {
                    method: "PUT",
                    headers: {
                        "Content-Type": "application/json",
                        authorization: `Bearer ${accessToken}`,
                    },
                    body: JSON.stringify(audioTrack)
                }).then((response) => {
                    if (response.status === 200) {
                        response.json().then((data: AudioTrack) => resolve(data)).catch(reject);
                    } else {
                        reject(new Error("Failed to update audio track: " + response.statusText));
                    }
                })
                    .catch(reject);
            }).catch(reject);
        });
    };

    const deleteAudioTrack = (id: string): Promise<AudioTrack> => {
        return new Promise((resolve, reject) => {
            getAccessTokenSilently().then((accessToken) => {
                fetch(`${process.env.REACT_APP_API_URL}/audio_track/admin/${id}`, {
                    method: "DELETE",
                    headers: {
                        "Content-Type": "application/json",
                        authorization: `Bearer ${accessToken}`,
                    }
                }).then((response) => {
                    if (response.status === 200) {
                        response.json().then((data: AudioTrack) => resolve(data)).catch(reject);
                    } else {
                        reject(new Error("Failed to delete audio track: " + response.statusText));
                    }
                })
                    .catch(reject);
            }).catch(reject);
        });
    };

    const backfillBeatData = (): Promise<{ submitted: number }> => {
        return new Promise((resolve, reject) => {
            getAccessTokenSilently().then((accessToken) => {
                fetch(`${process.env.REACT_APP_API_URL}/audio_track/admin/backfill-beats`, {
                    method: "POST",
                    headers: {
                        authorization: `Bearer ${accessToken}`,
                    },
                })
                    .then((response) => {
                        if (response.status === 200) {
                            response.json().then((data: { submitted: number }) => resolve(data)).catch(reject);
                        } else {
                            reject(new Error("Failed to backfill beat data: " + response.statusText));
                        }
                    })
                    .catch(reject);
            }).catch(reject);
        });
    };

    return {getAllAudioTracks, getAudioTrackById, createAudioTrack, updateAudioTrack, deleteAudioTrack, backfillBeatData};
}
